import { render } from "./fldTicket.vue?vue&type=template&id=132ec94c"
import script from "./fldTicket.vue?vue&type=script&lang=js"
export * from "./fldTicket.vue?vue&type=script&lang=js"

import "./fldTicket.vue?vue&type=style&index=0&id=132ec94c&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QField,QColor});
